import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';
import moment from 'moment';

export const PREPAID_TERMS_REPORT_REQUEST = 'PREPAID_TERMS_REPORT_REQUEST';
export const PREPAID_TERMS_REPORT_SUCCESS = 'PREPAID_TERMS_REPORT_SUCCESS';
export const PREPAID_TERMS_REPORT_FAILURE = 'PREPAID_TERMS_REPORT_FAILURE';

export const PREPAID_TERMS_EXPORT_REQUEST = 'PREPAID_TERMS_EXPORT_REQUEST';
export const PREPAID_TERMS_EXPORT_SUCCESS = 'PREPAID_TERMS_EXPORT_SUCCESS';
export const PREPAID_TERMS_EXPORT_FAILURE = 'PREPAID_TERMS_EXPORT_FAILURE';

export const loadPrepaidTermsReport = (options) => ({
	[CALL_API]: {
		types: [PREPAID_TERMS_REPORT_REQUEST, PREPAID_TERMS_REPORT_SUCCESS, PREPAID_TERMS_REPORT_FAILURE],
		endpoint: `api/reports/prepaidTerms`,
		request: options,
		schema: Schemas.PREPAID_TERMS_REPORT_ARRAY
	}
});

export const exportPrepaidTerms = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [PREPAID_TERMS_EXPORT_REQUEST, PREPAID_TERMS_EXPORT_SUCCESS, PREPAID_TERMS_EXPORT_FAILURE],
			endpoint: `api/reports/prepaidTerms/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `PrepaidTermsReport-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}